import React from 'react'
import RelatedPostCard from './RelatedPostCard'

const RelatedPosts = ({data}) => {
  return (
    <>
    <h4 className=' font-[600] text-[28px] mb-4'>Keep reading: </h4>
    <div className='flex flex-col gap-4'>
        {data?.slice(0,4).map((item, index) => (
         <RelatedPostCard item={item} key={index} />   
        ))}
    </div>
    </>
  )
}

export default RelatedPosts